// extracted by mini-css-extract-plugin
module.exports = {"warning_message":"_32bbee5fda--warning_message--ZX40Z"};